import { withInstall } from '@tav-ui/utils/with-install'
import FileView from './src/file-view.vue'
const TaFileView = withInstall(FileView)
export { TaFileView }
export default TaFileView
export * from './src/types'
